import LandingView from '../../views/landing';
import { getLangPaths, getMainPageProps } from '../api/_props';
const project = require('../../scripts/configs/project.json');

const LandingPage = () => {
    return <LandingView />;
};

export async function getStaticProps({ params }) {
    const defaultProps = getMainPageProps(params?.lang, '/', ['/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    return {
        props: {
            ...defaultProps?.props
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}

export default LandingPage;
